import { EnvironmentTypes } from './environment-types';

const domain = 'dev.finlistics-vm.com';
const backEnd = `https://api.${ domain }`;
const api = `${ backEnd }/api`;
const idp = `https://idp.${ domain }`;

export const environment = {
  type: EnvironmentTypes.Dev,
  production: true,

  alwaysSegments: true,
  analysisButtonsOnDashboard: true,

  userSolutionManagement: true,
  accountPlanSettings: true,
  privateAccountPlanSetting: true,
  po1KpiGroupedBySolutions: true,

  apiGateway: api,
  loginRedirect: `${ backEnd }/identity/identityprovider/authorize`,
  logoutRedirect: `${ backEnd }/identity/identityprovider/logout`,
  resetPassword: `${ idp }/Identity/Account/Manage/Password`,

  gtmId: 'GTM-5ZGHQS7',
  amplitudeKey: '88e5b4211c808d79018a75983b4bd283',
  shepherdKey: 'SHEPHERD-2EF39777-4A12-4EDC-88BB-60F61363D429',
  hotjarSiteId: null,
};
